module.exports = __webpack_public_path__ + "img/command-center.5cdeadbb.jpg";